import apiServices from "../../../../services/apiServices";
import eventBus from "../../../../src/main";
import router from "../../../../src/router/index";
import jwtDecode from "jwt-decode";
//import store from "../../index";

export default {
  state: {
    saveIp: "",
    saveBrowser: "",
    startOpt: 1,
    textRecover: "Voltar para ter acesso ao painel",
    textLogin: "Não consegue iniciar a sessão?",
    refStatusUnion: "d302d1",
    refStatusUnUnion: "e4d629",
    menu: null,
    user: {
      token: null,
      email: "",
      exp: ""
    },
    platform: "",
    spin: {
      loading: false,
      disabled: false
    }
  },
  mutations: {
    SET_MENU_OPT(state, value) {
      state.menu = value;
    },
    SET_MULTI_OPT(state, value) {
      state.startOpt = value;
    },
    SET_SAVE_IP(state, value) {
      state.saveIp = value;
    },
    SET_SAVE_BROWSER(state, value) {
      state.saveBrowser = value;
    },
    SET_CREDENTIALS(state, value) {
      state.token = value;
      apiServices.customizeHeader(value);
    },
    SET_LOAD_LOADING(state, value) {
      state.spin.loading = value;
    },
    SET_LOAD_DISABLED(state, value) {
      state.spin.disabled = value;
    },
    SET_DATA_USER(state, value) {
      state.user.email = value.Email;
      state.user.exp = value.exp;
    },
    SET_DATA_PLATFORM(state, value) {
      state.platform = value;
    },
    SET_LOGOUT(state) {
      state.user.token = null;
      state.user.email = "";
    }
  },
  actions: {
    login(context, value) {
      context.commit("SET_LOAD_LOADING", true);
      apiServices
        .getLogin(value)
        .then(function(response) {
          if (response.status === 200) {
            let obj = response.data;
            if (obj.code === 200) {
              let tokenSplit = response.headers.authorization;
              let token;
              token = tokenSplit.split("Bearer ");
              localStorage.setItem("token", token[1]);
              localStorage.setItem("platform", obj.scope_platform);
              context.commit("SET_CREDENTIALS", token[1]);
              const decode = jwtDecode(token[1]);
              context.commit("SET_DATA_USER", decode);
              context.commit("SET_DATA_PLATFORM", obj.scope_platform);
              let startWith = decode.Pub;
              let ref = startWith.substr(0, 6);
              let unUnion = startWith.substr(5, 6);
              if (ref === context.getters.getRefusion) {
                context.commit("SET_MENU_OPT", false);
                localStorage.setItem("Mopt", "xYzH");
                router.push("/console").catch(() => {
                  //throw new Error("Problem - Contact Sys factory");
                });
              }
              if (unUnion === context.getters.getRefusionUnunion) {
                context.commit("SET_MENU_OPT", true);
                localStorage.setItem("Mopt", "xYzN");
                router.push("/enterprise").catch(() => {
                  //throw new Error("Problem - Contact Sys factory");
                });
              }
            } else {
              let payload = {
                color: "error",
                text: "Ups! Verifique as suas credenciais",
                errorLogin: true,
                right: "right"
              };
              eventBus.$emit("openInfo", payload); // emit the event to the bus
            }
          } else {
            let payload = {
              color: "error",
              text: "Ups! Seu pedido não foi processado",
              errorLogin: true,
              right: "right"
            };
            eventBus.$emit("openInfo", payload); // emit the event to the bus
          }
        })
        .catch(function() {
          let payload = {
            color: "error",
            text: "Ups! Seu pedido não foi processado",
            errorLogin: true,
            right: "right"
          };
          eventBus.$emit("openInfo", payload); // emit the event to the bus
        })
        .finally(function() {
          context.commit("SET_LOAD_LOADING", false);
        });
    },

    resetPassword(context, value) {
      context.commit("SET_LOAD_LOADING", true);
      apiServices
        .resetPasswords(value)
        .then(function(response) {
          if (response.status === 200) {
            let obj = response.data;
            if (obj.code === 200) {
              context.commit("SET_LOAD_LOADING", false);
              let payload = {
                color: "success",
                text:
                  "Sucesso! - Confirme no seu e-mail o código de recuperação",
                errorLogin: true
              };
              eventBus.$emit("openInfo", payload); // emit the event to the bus
            } else {
              let payload = {
                color: "error",
                text: "Ups! Verifique seus credenciais",
                errorLogin: true
              };
              eventBus.$emit("openInfo", payload); // emit the event to the bus
            }
          } else {
            let payload = {
              color: "error",
              text: "Ups! Detectamos alguma incongruência",
              errorLogin: true
            };
            eventBus.$emit("openInfo", payload); // emit the event to the bus
          }
        })
        .catch(function() {
          let payload = {
            color: "error",
            text: "Ups! seu pedido não foi processado",
            errorLogin: true
          };
          eventBus.$emit("openInfo", payload); // emit the event to the bus
        })
        .finally(function() {
          context.commit("SET_LOAD_LOADING", false);
        });
    },

    recoverPassword(context, value) {
      context.commit("SET_LOAD_LOADING", true);
      apiServices
        .recoverPasswords(value)
        .then(function(response) {
          if (response.status === 200) {
            let obj = response.data;
            if (obj.code === 200) {
              context.commit("SET_LOAD_LOADING", false);
              let payload = {
                color: "success",
                text: "Sucesso! - A sua nova palavra passe foi criada",
                errorLogin: true
              };
              eventBus.$emit("openInfo", payload); // emit the event to the bus
            } else {
              let payload = {
                color: "error",
                text: "Ups! Seu pedido não foi processado",
                errorLogin: true
              };
              eventBus.$emit("openInfo", payload); // emit the event to the bus
            }
          } else {
            let payload = {
              color: "error",
              text: "Ups! Detectamos alguma incongruência",
              errorLogin: true
            };
            eventBus.$emit("openInfo", payload); // emit the event to the bus
          }
        })
        .catch(function() {
          let payload = {
            color: "error",
            text: "Ups! seu pedido não foi processado",
            errorLogin: true
          };
          eventBus.$emit("openInfo", payload); // emit the event to the bus
        })
        .finally(function() {
          context.commit("SET_LOAD_LOADING", false);
        });
    },

    logout(context) {
      context.commit("SET_LOGOUT");
      localStorage.removeItem("token");
      localStorage.removeItem("platform");
      localStorage.removeItem("myRef");
      localStorage.removeItem("Mopt");
      localStorage.removeItem("userString");
      localStorage.removeItem("iOpen");
      router.push("/").catch(() => {
        //throw new Error("Problem - Contact Sys factory");
      });
    },
    saveYouIp(context, value) {
      return context.commit("SET_SAVE_IP", value);
    },
    saveYouBrowser(context, value) {
      return context.commit("SET_SAVE_BROWSER", value);
    },
    startMultiOpt(context, value) {
      return context.commit("SET_MULTI_OPT", value);
    }
  },

  getters: {
    getUserTokenHeader(state) {
      return state.user.token;
    },
    getOptMenu(state) {
      if (
        (state.menu == null || !state.menu) &&
        localStorage.getItem("Mopt") === "xYzH"
      ) {
        return false;
      }

      if (
        (state.menu == null || state.menu === true) &&
        localStorage.getItem("Mopt") === "xYzN"
      ) {
        return true;
      }
    },
    getUserToken(state) {
      return !!state.user.token;
    },
    getLoadingSpin(state) {
      return state.spin.loading;
    },
    getDisabledButton(state) {
      return state.spin.disabled;
    },
    getEmail(state) {
      return state.user.email;
    },
    getUserID(state) {
      return state.user.ca;
    },
    getYourIp(state) {
      return state.saveIp;
    },
    getYourBrowser(state) {
      return state.saveBrowser;
    },
    getMultiOpt(state) {
      return state.startOpt;
    },
    getTextRecover(state) {
      return state.textRecover;
    },
    getTextLogin(state) {
      return state.textLogin;
    },
    getRefusion(state) {
      return state.refStatusUnion;
    },
    getRefusionUnunion(state) {
      return state.refStatusUnUnion;
    }
  }
};
